let FileUploadsDirective = () => {
     return {
          restrict: 'E',
          scope: {
               ngModel: '=',
               ngDisabled: '=',
               fileTypes: '@',
               selectedFiles: '='
          },
          require: {
               ngModel: 'ngModel'
          },
          templateUrl: `file-upload.html`,
          link: function (scope, element, attrs, controller) {

               var fileInput = element[0].querySelector('[type=file]');
               var btnClass = element[0].querySelector('.button');

               scope.$watch(() => attrs.btnClass, (newVal) => {
                    if (btnClass && newVal && newVal.indexOf(' ') < 0) {
                         btnClass.classList.add(newVal);
                    }
               });

               scope.$watch('fileTypes', (newVal) => {
                    if (fileInput && newVal) {
                         fileInput.setAttribute('accept', newVal);
                    }
               });

               scope.$watch(() => attrs.multiple, (newVal) => {
                    if (fileInput) {
                         const isMultiple = newVal === 'true' || newVal === true;
                         if (isMultiple) {
                              fileInput.setAttribute('multiple', 'multiple');
                         } else {
                              fileInput.removeAttribute('multiple');
                         }
                    }
               });

               element.bind('change', (changed) => {
                    controller.ngModel.path = fileInput.value;
                    controller.ngModel.info = fileInput.files;
                    if (changed.target.files.length < 1) {
                         return;
                    }

                    const imagetype = ['image/jpeg',  'image/png', 'image/jpg'];
                    const fileTypes = ['text/csv', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 
                                       'application/vnd.ms-excel', 'application/msword',
                                       'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

                    const files = Array.from(changed.target.files);
                    const isMultiple = attrs.multiple === 'true' || attrs.multiple === true;

                    // If it is running in SINGLE file mode, clear the array before adding the new file
                    if (!isMultiple) {
                         scope.selectedFiles = [];
                    } else {
                         scope.selectedFiles = scope.selectedFiles || [];
                    }

                    angular.forEach(files, function (item) {
                         if (fileTypes.includes(item.type) || imagetype.includes(item.type)) {
                              if (imagetype.includes(item.type) && !isMultiple) {
                                   scope.selectedFiles = [];
                              }

                              var value = {
                                   fileName: item.name,
                                   size: item.size,
                                   lastModifiedDate: item.lastModifiedDate,
                                   type: item.type,
                                   _file: item
                              };
                              scope.selectedFiles.push(value);
                         }
                    });

                    scope.selectedFiles = _.uniqBy(scope.selectedFiles, 'fileName');
                    const compress = attrs.compress === 'true' || attrs.compress === true;

                    for (let i = 0, f; f = scope.selectedFiles[i]; i++) {
                         let currentFile = f;
                         
                         // New optimization logic: skip reading if base64 data already exists or if already processed
                         if (currentFile.base64Data || currentFile.processed) {
                              continue;
                         }

                         const isImage = compress && currentFile.type && currentFile.type.startsWith('image/');

                         if (isImage) {
                              var reader = new FileReader();
                              reader.onload = function (e) {
                                   var img = new Image();
                                   img.onload = function () {
                                        // Maximum bounding box dimensions
                                        var MAX_WIDTH = 1600;
                                        var MAX_HEIGHT = 1600;
                                        var width = img.width;
                                        var height = img.height;

                                        // Maintain correct aspect ratio
                                        if (width > height) {
                                             if (width > MAX_WIDTH) {
                                                  height *= MAX_WIDTH / width;
                                                  width = MAX_WIDTH;
                                             }
                                        } else {
                                             if (height > MAX_HEIGHT) {
                                                  width *= MAX_HEIGHT / height;
                                                  height = MAX_HEIGHT;
                                             }
                                        }

                                        var canvas = document.createElement('canvas');
                                        canvas.width = width;
                                        canvas.height = height;
                                        var ctx = canvas.getContext('2d');
                                        ctx.drawImage(img, 0, 0, width, height);

                                        // Extract canvas directly as a binary BLOB
                                        canvas.toBlob(function (blob) {
                                             const compressedFile = new File([blob], currentFile.fileName, { type: 'image/jpeg' });
                                             scope.$apply(() => {
                                                  currentFile._file = compressedFile;
                                                  currentFile.size = compressedFile.size;
                                                  currentFile.imageUrl = URL.createObjectURL(compressedFile);
                                                  currentFile.processed = true;
                                             });
                                        }, 'image/jpeg', 0.75); // 75% Quality JPEG
                                   };
                                   
                                   img.onerror = function () {
                                        // Fallback: If canvas trick fails, keep original file and mark processed
                                        scope.$apply(() => {
                                             currentFile.imageUrl = URL.createObjectURL(currentFile._file);
                                             currentFile.processed = true;
                                        });
                                   };
                                   img.src = e.target.result;
                              };
                              reader.readAsDataURL(currentFile._file);
                         } else {
                              if (compress) {
                                   // For compress mode (service tickets), we keep original binary file as is
                                   currentFile.processed = true;
                              } else {
                                   // Original behavior for other parts of the app: read raw as base64
                                   var reader = new FileReader();
                                   reader.onloadend = function (output) {
                                        scope.$apply(() => {
                                             currentFile.base64Data = output.target.result.split(',')[1];
                                             currentFile.processed = true;
                                        });
                                   };
                                   reader.readAsDataURL(currentFile._file);
                              }
                         }
                    }

                    controller.ngModel.$$rawModelValue = scope.selectedFiles;
                    controller.ngModel.$viewValue = scope.selectedFiles;
                    controller.ngModel.$setViewValue(scope.selectedFiles);
                    
                    fileInput.value = '';
                    
                    scope.$apply(); 
               });
          }
     }
}

export default FileUploadsDirective;


// WEBPACK FOOTER //
// ./client/app/common/file-upload/file-upload.directive.js